import blog1 from "../../Assets/blog-1.png";
import blog2 from "../../Assets/blog-2.png";
import blog3 from "../../Assets/blog-3.png";

const blogs = [
    {
        id: 1,
        slug: "ecommerce-platform-migration",
        category: "Category A",
        title: "Offshore vs In-House Development: What Works Better in 2026? ",
        date: "07 Feb 2025",
        author: "John Doe",
        readTime: "4 min read",
        image:
            blog1,
        intro:
            "Migrating ecommerce platforms requires strategic planning and execution.",
        sections: [
            {
                id: "summary",

                title: "Executive Summary",

                content: `
                Choosing between offshore and in-house development impacts scalability, operational cost, flexibility and long-term delivery.`,

                list: [
                    "In-house teams provide control and product ownership",

                    "Offshore teams enable speed, scalability and flexibility",

                    "Most businesses are adopting a hybrid approach",

                    "The real shift in 2026: Companies are optimizing team structure for delivery efficiency, not just hiring",
                ],
            },

            {
                "id": "introduction",
                "title": "Introduction",
                "content": [
                    "The way companies build software teams has changed a lot.",

                    "In 2026, the question is not just whether to hire developers. It is how to build a team structure that can scale, stay stable, and keep delivery moving.",

                    "It has evolved into:"
                ],

                "list": [
                    "How do we scale faster without increasing overhead?",

                    "How do we maintain continuity across releases?",

                    "How do we reduce delays caused by hiring and restructuring?"
                ],

                "highlightText": "This is where the comparison between offshore vs in-house development becomes important.",

                "bottomContent": [
                    "Both models work.",

                    "But they work differently, and more importantly, they work better in different business contexts."
                ]
            },

            {
                id: "models",

                title:
                    "Understanding the Two Development Models",

                subSections: [
                    {
                        heading:
                            "What is an In-House Team?",

                        text: `
An internal engineering team working directly within your organization.

• Better collaboration
• Strong product ownership
• Improved communication
            `,
                    },

                    {
                        heading:
                            "What is Offshore Development?",

                        text: `
Offshore development enables businesses to work with remote global engineering teams.
            `,
                    },
                ],
            },

            {
                id: "comparison",

                title:
                    "Offshore vs In-House Development",

                table: {
                    headers: [
                        "Factor",
                        "In-House",
                        "Offshore",
                    ],

                    rows: [
                        [
                            "Cost",
                            "Higher",
                            "Lower",
                        ],

                        [
                            "Scalability",
                            "Limited",
                            "Flexible",
                        ],

                        [
                            "Control",
                            "High",
                            "Moderate",
                        ],

                        [
                            "Speed",
                            "Moderate",
                            "Fast",
                        ],
                    ],
                },
            },

            {
                id: "decision",

                title:
                    "What Actually Impacts the Decision",

                subSections: [
                    {
                        heading:
                            "1. Speed of Team Setup",

                        text: `
Offshore teams provide faster onboarding and flexibility.
            `,
                    },

                    {
                        heading:
                            "2. Delivery Consistency",

                        text: `
In-house teams improve internal communication and business alignment.
            `,
                    },
                ],


            },
            {
                id: "deliveryComparison",

                type: "comparisonCard",

                title:
                    "Offshore vs In-House – What Drives Better Delivery",

                headers: {
                    factor: "Factors",

                    inHouse: "In-house Development",

                    offshore: "Offshore Development",
                },

                rows: [
                    {
                        factor: "Speed",

                        inHouse: false,

                        offshore: true,
                    },

                    {
                        factor: "Cost flexibility",

                        inHouse: false,

                        offshore: true,
                    },

                    {
                        factor: "Control",

                        inHouse: true,

                        offshore: false,
                    },

                    {
                        factor: "Scalability",

                        inHouse: false,

                        offshore: true,
                    },

                    {
                        factor: "Continuity",

                        inHouse: false,

                        offshore: true,
                    },
                ],
            },

            {
                id: "hybrid",

                title:
                    "The Rise of Hybrid Development Models",

                content: `
Modern organizations combine internal leadership with offshore execution teams.

This creates a balance between cost optimization and product control.
        `,
            },

            {
                id: "conclusion",

                title: "Conclusion",

                content: `
Offshore and in-house development each provide unique benefits depending on business priorities and operational goals.
        `,
            },
        ],

        cta: {
            title:
                "Choosing the Right Model Starts with Your Needs",

            buttonText:
                "SCHEDULE CONSULTATION",
        },

        faq: [
            {
                question:
                    "Which is more cost-effective?",

                answer:
                    "Offshore development is generally more affordable.",
            },

            {
                question:
                    "Is offshore scalable?",

                answer:
                    "Yes. Offshore teams scale rapidly.",
            },
        ],
    },

    {
        id: 2,
        slug: "ruby-on-rails-development",
        category: "Category B",
        title: "What Makes Ruby on Rails Suitable for Rapid Product Development",
        date: "07 Feb 2025",
        author: "John Doe",
        readTime: "4 min read",
        image:
            blog2,
        intro:
            "Ruby on Rails accelerates product development with convention over configuration.",
        sections: [
            {
                id: "summary",

                title: "Executive Summary",

                content: `
Choosing between offshore and in-house development impacts scalability, operational cost, flexibility and long-term delivery.

• Offshore reduces development cost
• In-house improves visibility
• Hybrid teams are increasingly common
        `,
            },

            {
                id: "introduction",

                title: "Introduction",

                content: `
Technology decisions directly impact business growth, scalability and operational efficiency in 2026.

Businesses are increasingly evaluating whether offshore or in-house development provides better outcomes.
        `,
            },

            {
                id: "models",

                title:
                    "Understanding the Two Development Models",

                subSections: [
                    {
                        heading:
                            "What is an In-House Team?",

                        text: `
An internal engineering team working directly within your organization.

• Better collaboration
• Strong product ownership
• Improved communication
            `,
                    },

                    {
                        heading:
                            "What is Offshore Development?",

                        text: `
Offshore development enables businesses to work with remote global engineering teams.
            `,
                    },
                ],
            },

            {
                id: "comparison",

                title:
                    "Offshore vs In-House Development",

                table: {
                    headers: [
                        "Factor",
                        "In-House",
                        "Offshore",
                    ],

                    rows: [
                        [
                            "Cost",
                            "Higher",
                            "Lower",
                        ],

                        [
                            "Scalability",
                            "Limited",
                            "Flexible",
                        ],

                        [
                            "Control",
                            "High",
                            "Moderate",
                        ],

                        [
                            "Speed",
                            "Moderate",
                            "Fast",
                        ],
                    ],
                },
            },

            {
                id: "decision",

                title:
                    "What Actually Impacts the Decision",

                subSections: [
                    {
                        heading:
                            "1. Speed of Team Setup",

                        text: `
Offshore teams provide faster onboarding and flexibility.
            `,
                    },

                    {
                        heading:
                            "2. Delivery Consistency",

                        text: `
In-house teams improve internal communication and business alignment.
            `,
                    },
                ],

                card: {
                    title:
                        "Offshore vs In-House",

                    subtitle:
                        "What Drives Better Delivery",
                },
            },

            {
                id: "hybrid",

                title:
                    "The Rise of Hybrid Development Models",

                content: `
Modern organizations combine internal leadership with offshore execution teams.

This creates a balance between cost optimization and product control.
        `,
            },

            {
                id: "conclusion",

                title: "Conclusion",

                content: `
Offshore and in-house development each provide unique benefits depending on business priorities and operational goals.
        `,
            },
        ],

        cta: {
            title:
                "Choosing the Right Model Starts with Your Needs",

            buttonText:
                "SCHEDULE CONSULTATION",
        },

        faq: [
            {
                question:
                    "Which is more cost-effective?",

                answer:
                    "Offshore development is generally more affordable.",
            },

            {
                question:
                    "Is offshore scalable?",

                answer:
                    "Yes. Offshore teams scale rapidly.",
            },
        ],
    },

    {
        id: 3,
        slug: "offshore-vs-inhouse-development",
        category: "Category C",
        title: "Offshore vs In-House Development: What Works Better in 2026?",
        date: "07 Feb 2025",
        author: "John Doe",
        readTime: "4 min read",
        image:
            blog3,
        intro:
            "Choosing the right development model impacts cost, scalability and delivery.",
        sections: [
            {
                id: "summary",

                title: "Executive Summary",

                content: `
Choosing between offshore and in-house development impacts scalability, operational cost, flexibility and long-term delivery.

• Offshore reduces development cost
• In-house improves visibility
• Hybrid teams are increasingly common
        `,
            },

            {
                id: "introduction",

                title: "Introduction",

                content: `
Technology decisions directly impact business growth, scalability and operational efficiency in 2026.

Businesses are increasingly evaluating whether offshore or in-house development provides better outcomes.
        `,
            },

            {
                id: "models",

                title:
                    "Understanding the Two Development Models",

                subSections: [
                    {
                        heading:
                            "What is an In-House Team?",

                        text: `
An internal engineering team working directly within your organization.

• Better collaboration
• Strong product ownership
• Improved communication
            `,
                    },

                    {
                        heading:
                            "What is Offshore Development?",

                        text: `
Offshore development enables businesses to work with remote global engineering teams.
            `,
                    },
                ],
            },

            {
                id: "comparison",

                title:
                    "Offshore vs In-House Development",

                table: {
                    headers: [
                        "Factor",
                        "In-House",
                        "Offshore",
                    ],

                    rows: [
                        [
                            "Cost",
                            "Higher",
                            "Lower",
                        ],

                        [
                            "Scalability",
                            "Limited",
                            "Flexible",
                        ],

                        [
                            "Control",
                            "High",
                            "Moderate",
                        ],

                        [
                            "Speed",
                            "Moderate",
                            "Fast",
                        ],
                    ],
                },
            },

            {
                id: "decision",

                title:
                    "What Actually Impacts the Decision",

                subSections: [
                    {
                        heading:
                            "1. Speed of Team Setup",

                        text: `
Offshore teams provide faster onboarding and flexibility.
            `,
                    },

                    {
                        heading:
                            "2. Delivery Consistency",

                        text: `
In-house teams improve internal communication and business alignment.
            `,
                    },
                ],

                card: {
                    title:
                        "Offshore vs In-House",

                    subtitle:
                        "What Drives Better Delivery",
                },
            },

            {
                id: "hybrid",

                title:
                    "The Rise of Hybrid Development Models",

                content: `
Modern organizations combine internal leadership with offshore execution teams.

This creates a balance between cost optimization and product control.
        `,
            },

            {
                id: "conclusion",

                title: "Conclusion",

                content: `
Offshore and in-house development each provide unique benefits depending on business priorities and operational goals.
        `,
            },
        ],

        cta: {
            title:
                "Choosing the Right Model Starts with Your Needs",

            buttonText:
                "SCHEDULE CONSULTATION",
        },

        faq: [
            {
                question:
                    "Which is more cost-effective?",

                answer:
                    "Offshore development is generally more affordable.",
            },

            {
                question:
                    "Is offshore scalable?",

                answer:
                    "Yes. Offshore teams scale rapidly.",
            },
        ],
    },
];

export default blogs;